export default "__VITE_ASSET__Q$UVRrBx1SbqCrj4Xi237g__"